export const SET_DEADLINES = 'SET_DEADLINES'
export const SET_TOTAL_DEADLINES = 'SET_TOTAL_DEADLINES'
export const ADD_DEADLINE = 'ADD_DEADLINE'
export const UPDATE_DEADLINE = 'UPDATE_DEADLINE'
export const DELETE_DEADLINE = 'DELETE_DEADLINE'
